import Vue from "vue";
import axios from "axios";
import apiCall from "./api";

export const SESSION_TIMEOUT_MS = 20 * 60 * 1000;
export const SESSION_WARNING_SECONDS = 30;

export const sessionState = Vue.observable({
  expiresAt: null,
  warningHidden: false,
  secondsRemaining: Infinity,
});

let tickInterval = null;

export function resetSessionTimer(expiresAt = null) {
  if (expiresAt) {
    sessionState.expiresAt =
      typeof expiresAt === "number" ? expiresAt : new Date(expiresAt).getTime();
  } else {
    sessionState.expiresAt = Date.now() + SESSION_TIMEOUT_MS;
  }
  sessionState.warningHidden = false;
  updateSecondsRemaining();
}

export function clearSessionTimer() {
  sessionState.expiresAt = null;
  sessionState.warningHidden = false;
  sessionState.secondsRemaining = Infinity;
}

export function hideSessionWarning() {
  sessionState.warningHidden = true;
}

export function updateSecondsRemaining() {
  if (!sessionState.expiresAt) {
    sessionState.secondsRemaining = Infinity;
    return Infinity;
  }
  const remaining = Math.max(
    0,
    Math.floor((sessionState.expiresAt - Date.now()) / 1000)
  );
  sessionState.secondsRemaining = remaining;
  return remaining;
}

export function formatCountdown(seconds) {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${String(secs).padStart(2, "0")}`;
}

export async function refreshSessionWithServer() {
  const response = await apiCall({
    url: "/api/client/session/refresh",
    method: "GET",
  });
  resetSessionTimer(response.expires_at);
  return response;
}

export function initSessionTimeoutWatch(onExpired) {
  if (tickInterval) {
    return;
  }
  tickInterval = setInterval(() => {
    const remaining = updateSecondsRemaining();
    const isAuthenticated = !!localStorage.getItem("user-token");
    if (remaining === 0 && isAuthenticated && typeof onExpired === "function") {
      onExpired();
    }
  }, 1000);
}

let activityTrackingInitialized = false;

export function initSessionActivityTracking() {
  if (activityTrackingInitialized) {
    return;
  }
  activityTrackingInitialized = true;

  axios.interceptors.response.use(
    (response) => {
      if (localStorage.getItem("user-token")) {
        resetSessionTimer();
      }
      return response;
    },
    (error) => Promise.reject(error)
  );
}
